// extracted by mini-css-extract-plugin
export default {"allocating":"Donations_allocating__afyvc","header":"Donations_header__Zz+Ue","filters":"Donations_filters__xbENx","filter-row":"Donations_filter-row__gcbzc"};